/**
 * Labstep
 */

import { SignatureListEntityStateContainer as SignatureListEntityState } from 'labstep-web/components/Signature/List/EntityState';
import type React from 'react';
import type { ExperimentWorkflowActionUpdateEntityStateModalWizardStepSignaturesProps } from './types';

export const ExperimentWorkflowActionUpdateEntityStateModalWizardStepSignatures: React.FC<
  ExperimentWorkflowActionUpdateEntityStateModalWizardStepSignaturesProps
> = ({ experimentWorkflow, entityState }) => {
  return (
    <SignatureListEntityState
      entityState={entityState}
      experimentWorkflow={experimentWorkflow}
      round={experimentWorkflow.entity_state_round}
      showState={false}
    />
  );
};
